import { getByKey_Boolean } from './Utils'

// ***** NOTE *****
// Everything in this selector retrieves the instance level configuration value first
// and then if there is nothing there, it'll go grab the ORG level configuration value.

/**
 * Retrieve if the developer_featureEnabled flag is on/off in VNConfigs
 * @param {*} state
 * @returns {Boolean} true if it is enabled, false otherwise
 */
export const getEnabledDeveloperFeature = (state) => {
  return getByKey_Boolean(state, 'developer_featureEnabled')
}

/**
 * Retrieve if the ppi_staticCredentialCompareOnly flag is on/off in VNConfigs
 * @param {*} state
 * @returns {Boolean} true if it is enabled, false otherwise
 */
export const getPpiStaticCredentialCompareOnly = (state) => {
  return getByKey_Boolean(state, 'ppi_staticCredentialCompareOnly')
}
